import { supportsHover as supportsHoverHelper } from '@bridebook/aura';
import { DateInputDesktop } from './date-input-desktop';
import { DateInputMobile } from './date-input-mobile';
import type { DateInputProps } from './types';

/** Router component — picks mobile or desktop date input based on device capability. */
export const DateInput = ({ isTouchDevice: isTouchDeviceProp, ...props }: DateInputProps) => {
  const isTouchDevice = isTouchDeviceProp ?? !supportsHoverHelper();

  if (isTouchDevice) {
    return <DateInputMobile {...props} />;
  }

  return <DateInputDesktop {...props} />;
};
